import _ from 'lodash';
import React from 'react';
import {Radio} from 'semantic-ui-react';
import {FemaGoTable} from 'app-ui-componentlibrary';

const SearchResultsForCommitment = ({results, handleCommitmentSelect}) => {
  /* Insert logic to handle incoming search results from props and parse table rows
  with radio buttons. Will aslo need mergedFOC data to compare incoming results against */

  return (
    <FemaGoTable columns={results.length} withForm={false} summary={'Search Results'}>
      <FemaGoTable.Header>
        <FemaGoTable.Row>
          <FemaGoTable.HeaderCell>
            Commitment number - sequence number
          </FemaGoTable.HeaderCell>
          <FemaGoTable.HeaderCell>Commitment start date</FemaGoTable.HeaderCell>
          <FemaGoTable.HeaderCell>Commitment end date</FemaGoTable.HeaderCell>
          <FemaGoTable.HeaderCell>ACCS code</FemaGoTable.HeaderCell>
          <FemaGoTable.HeaderCell>Available amount</FemaGoTable.HeaderCell>
        </FemaGoTable.Row>
      </FemaGoTable.Header>
      <FemaGoTable.Body>
        {_.map(results, (rowData) => {
          return (
            <FemaGoTable.Row>
              <FemaGoTable.TextCell>
                <Radio
                  title={
                    'Commitment Number - Sequence Number' +
                    _.get(rowData, 'commitmentIdAndSeq', 'N/A')
                  }
                  label={_.get(rowData, 'commitmentIdAndSeq', 'N/A')}
                  name="selectedCommitmentId"
                  onChange={() => handleCommitmentSelect(rowData)}
                />
              </FemaGoTable.TextCell>
              <FemaGoTable.TextCell>
                {_.get(rowData, 'commitmentStartDate', 'N/A')}
              </FemaGoTable.TextCell>
              <FemaGoTable.TextCell>
                {_.get(rowData, 'commitmentEndDate', 'N/A')}
              </FemaGoTable.TextCell>
              <FemaGoTable.TextCell>
                {_.get(rowData, 'accsline', 'N/A')}
              </FemaGoTable.TextCell>
              <FemaGoTable.TextCell>
                {_.get(rowData, 'commitmentAvailableAmount', 'N/A')}
              </FemaGoTable.TextCell>
            </FemaGoTable.Row>
          );
        })}
      </FemaGoTable.Body>
    </FemaGoTable>
  );
};

export default SearchResultsForCommitment;
